import React, { useContext, useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import logo4 from "../../../assets/images/logo4.png";
import IconPrinter25 from "../../../assets/images/IconPrinter25.png";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { TransferContext } from "../../../context/TransferContext";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    background: "white",
    borderRadius: "5px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
    // marginBottom: "30px",
    marginTop: "20px",
  },

  marginBottomStyle: {
    // marginBottom: "10px",
  },

  rightAlign: {
    textAlign: "right",
  },
  centerAlign: {
    textAlign: "center",
  },

  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  backButton: {
    fontSize: "16px",
    "&:hover": {
      background: "none",
    },
    color: "#19181699",
  },
  greenColor: {
    color: "#35B522",
  },
  leftLabel: {
    marginRight: "15px",
  },
  rightLabel: {
    fontSize: "16px",
    fontWeight: 600,
  },
  marginBottom10: {
    marginBottom: "10px",
  },
  tabletitle: {
    background: "#EFEFFA",
    fontWeight: 600,
    marginTop: "10px",
    marginBottom: "10px",
    padding: "5px 15px",
  },
  tableStyle: {
    "& td": {
      borderBottom: "none !important",
      padding: "0px 24px 6px 16px",
    },
    "& td:first-child": {
      width: "170px",
    },
  },
  tableStyle2: {
    "& td": {
      borderBottom: "none !important",
      padding: "0px 0px 6px 16px !important",
    },
    "& td:first-child": {
      width: "170px",
    },
    "& td:last-child": {
      width: "55px",
    },
    "& tr:last-child td": {
      fontWeight: 600,
    },
  },
  tablePadding: {
    paddingRight: "40px !important",
  },
}));

const GenerateReceipt = () => {
  const classes = useStyles();
  const { transfer } = useContext(TransferContext);
  const [data, setData] = useState({});

  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    setData(transfer.receipt);
    console.log("receipt data", transfer.receipt);
  }, []);
  return (
    <>
      <Grid container alignItems="center">
        {/* <Grid item xs={6}>
          <Typography variant="h4" className={classes.marginBottomStyle}>
            Money Transfer Receipt
          </Typography>
        </Grid> */}
        <Grid item xs={12} className={classes.rightAlign}>
          <Button
            variant="contained"
            color="primary"
            className={classes.buttonStyle}
            startIcon={<img src={IconPrinter25} alt="" />}
            onClick={handlePrint}
          >
            Print
          </Button>
        </Grid>
      </Grid>
      <div className={classes.root}  ref={printRef}>
        <Grid container justifyContent="center" alignItems="center" spacing={1}>
          <Grid item xs={6}>
            <img src={logo4} alt="" style={{ maxHeight: 40, width: "auto", objectFit: "contain" }} />
          </Grid>
          <Grid item xs={4} className={classes.rightAlign}>
            <Typography variant="body1">Transaction Number</Typography>
          </Grid>
          <Grid item xs={2} className={classes.rightAlign}>
            <Typography variant="h5"> {data.transactionNumber} </Typography>
          </Grid>
          <Grid item xs={12} className={classes.rightAlign}>
            <Divider className={classes.marginBottom10} />
          </Grid>
          <Grid item xs={4}>
            <label className={classes.leftLabel}>Date</label>{" "}
            <label className={classes.rightLabel}>
              {" "}
              {moment().format("DD MMM  YYYY")}{" "}
            </label>
          </Grid>
          <Grid item xs={4} className={classes.centerAlign}>
            {/* <label className={classes.leftLabel}>Local Time</label>{" "}
            <label className={classes.rightLabel}>
              {moment().format(" H:mm")}
            </label> */}
          </Grid>
          <Grid item xs={4} className={classes.rightAlign}>
            <label className={classes.leftLabel}>UCT Time</label>{" "}
            <label className={classes.rightLabel}>
              {moment().format(" H:mm")}
            </label>
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={7} className={classes.tablePadding}>
            <Typography className={classes.tabletitle}>
              Sender Details
            </Typography>
            <TableContainer>
              <Table
                className={classes.tableStyle}
                size="small"
                aria-label="caption table"
              >
                <TableBody>
                  <TableRow>
                    <TableCell>Full Name</TableCell>
                    <TableCell>{data.sender && data.sender.fullName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Address</TableCell>
                    <TableCell>{data.sender && data.sender.address}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Mobile Number</TableCell>
                    <TableCell>
                      {data.sender && data.sender.mobileNumber}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Document Type</TableCell>
                    <TableCell>
                      {data.sender && data.sender.documentType}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Document Number</TableCell>
                    <TableCell>
                      {data.sender && data.sender.documentNumber}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={5}>
            <Typography className={classes.tabletitle}>
              Money Collection Point
            </Typography>
            <TableContainer>
              <Table
                className={classes.tableStyle}
                size="small"
                aria-label="caption table"
              >
                <TableBody>
                  <TableRow>
                    <TableCell>MFS Name</TableCell>
                    <TableCell>
                      {data.receiverMfsAccount &&
                        data.receiverMfsAccount.mfsName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Country</TableCell>
                    <TableCell>{data.countryName}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={7} className={classes.tablePadding}>
            <Typography className={classes.tabletitle}>
              Receiver Details
            </Typography>
            <TableContainer>
              <Table
                className={classes.tableStyle}
                size="small"
                aria-label="caption table"
              >
                <TableBody>
                  <TableRow>
                    <TableCell>Account Name</TableCell>
                    <TableCell>
                      {data.receiverMfsAccount &&
                        data.receiverMfsAccount.accountName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Account Number</TableCell>
                    <TableCell>
                      {data.receiverMfsAccount &&
                        data.receiverMfsAccount.accountNumber}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={5}>
            <Typography className={classes.tabletitle}>
              Transferred Amount
            </Typography>
            <TableContainer>
              <Table
                className={classes.tableStyle2}
                size="small"
                aria-label="caption table"
              >
                <TableBody>
                  {/* <TableRow>
                    <TableCell>Exchange Rate</TableCell>
                    <TableCell align="right">84.76</TableCell>
                    <TableCell align="right"></TableCell>
                  </TableRow> */}
                  <TableRow>
                    <TableCell>Amount Sent</TableCell>
                    <TableCell align="right">
                      {data.transaction &&
                        data.transaction.amountToTransfer.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      {data.transaction && data.transaction.fromCurrency}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Charge</TableCell>
                    <TableCell align="right">
                      {data.transaction && data.transaction.charge}
                    </TableCell>
                    <TableCell align="right">
                      {data.transaction && data.transaction.fromCurrency}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Total</TableCell>
                    <TableCell align="right">
                      {data.transaction &&
                        data.transaction.amountReceivable.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      {data.transaction && data.transaction.toCurrency}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Recipient Gets</TableCell>
                    <TableCell align="right">
                      {data.transaction &&
                        data.transaction.amountReceivable.toFixed(2)}
                    </TableCell>
                    <TableCell align="right">
                      {data.transaction && data.transaction.toCurrency}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default GenerateReceipt;
